import { Button, FormControl, TextField } from '@material-ui/core';
import styled from 'styled-components';

interface Iprops {
  identificationKeyError?: boolean;
  ownershipTypeError?: boolean;
  messageError?: boolean;
}

interface ModalLGPDProps {
  isOpen?: boolean;
}

export const ModalLGPD = styled.div<ModalLGPDProps>`
  background: red;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  overflow: hidden;
  display: none;
  opacity: ${props => (!props.isOpen ? 1 : 0)};
  transition: opacity 5s linear;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #292828;

  .search-event {
    width: 100%;
    display: flex;
    flex-direction: row;

    padding-bottom: 40px;
    border-bottom: 1px #707070 solid;

    .PickerLGPD {
      justify-content: flex-start;

      margin-right: 30px;

      & + div {
        margin-right: 30px;
      }

      .MuiFormControl-root {
        border: 1px solid;
        border-radius: 4px;
        width: 165px;
        padding: 0 14px;
        height: 53px;
        margin: 0;
        position: relative;
        border-color: #929292;

        .MuiFormLabel-root {
          position: absolute;
          top: -7px;
          font-size: 1.4rem;
          color: #fff;
          padding: 0 5px;
          background: #292828;
          margin: 0 8px;
        }

        .MuiInputBase-root {
          margin-top: 13px;
          color: #fff;
          font-size: 1.4rem;

          &:before {
            border: 0;
          }

          &:after {
            border: 0;
          }
        }

        .MuiButtonBase-root {
          color: #fff;
        }
      }
    }
  }

  .fade-lgpd {
    opacity: 0;
    transition: opacity 5s linear;
  }

  .test-1 {
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    overflow: hidden;
    display: none;

    .modal-dialog-lgpd {
      width: 600px;
      margin: 30px auto;
    }

    .modal-content-lgpd {
      background: #fff;
    }
  }

  .fade-in-lgpd {
    opacity: 1;
    display: block;
    transition: opacity 5s linear;
  }

  .modal-lgpd {
  }

  .titululo-atividades {
    font-size: 24px;
    color: #fff;
    margin-bottom: 40px;
  }

  .table-lgpd {
    .MuiToolbar-root {
      color: #fff;
    }

    .MuiTablePagination-selectRoot {
      display: none;
    }

    .MuiPaper-root {
      background-color: ${props => props.theme.colors.primaryBackground};
      border: 1px solid #707070;

      .MuiTableHead-root {
        .MuiButtonBase-root {
          color: ${props => props.theme.colors.primaryText};
        }

        .MuiSvgIcon-root {
          color: ${props => props.theme.colors.primaryText} !important;
        }
      }

      .MuiTableBody-root {
        .MuiTableCell-root {
        }

        .MuiTableCell-body {
          color: ${props => props.theme.colors.primaryText};
        }

        .Mui-selected {
          background-color: rgba(0, 69, 245, 0.08);
        }

        .MuiCheckbox-root {
          color: ${props => props.theme.colors.primaryText};
        }

        .Mui-checked {
          color: #136edb !important;
        }

        .MuiButtonBase-root {
          &:hover {
            background-color: rgba(0, 69, 245, 0.08);
          }
        }
      }
    }
  }

  .rw-multiselect {
    width: 255px;
    margin-top: 7px;

    .Multiselect-lgpd {
      box-shadow: none;
      border: none;
      border-bottom: #ccc 1px solid;
      padding-top: 10px;
    }

    .Multiselect-lgpd-error {
      border-bottom: #c53030 1px solid;
    }

    .rw-list-empty {
      display: none;
    }
  }

  .tito_de_titular_de_dados {
    position: absolute;
    top: 286px;
    font-size: 1.2rem;
    color: #8a8a8a;
    z-index: 10;
  }

  .tito_de_titular_de_dados-error {
    color: #c53030;
  }

  .buttonGroup {
    .ajuda {
      border-radius: 24px !important;
      width: 150px;
      height: 40px;
      margin-right: 20px;
      border: 1px solid rgb(255 255 255);
      color: #fff;
    }
  }

  .TextField-lgpd {
    width: 100%;
    max-width: 255px;

    > label {
      font-size: 1.4rem;
    }

    .MuiInputBase-root {
      font-size: 1.4rem;

      input {
        color: #fff;
        font-size: 1.4rem;
      }
      fieldset {
        border-color: #929292;
      }
    }
  }

  .modal-lgpd-inf-historico {
    .modal-header {
      background: #292828;
      color: #fff;
    }
    .modal-body {
      background: #292828;
    }
  }

  .modal-lgpd {
    pointer-events: none;

    .modal-dialog-lgpd {
      pointer-events: all;
      width: 80%;
    }

    .button-close-modal {
      position: absolute;
      top: 14px;
      right: 23px;
      color: #525252;
      opacity: 1;
      border-radius: 50px;
      background: #c3c3c3;
      padding: 5px 10px;
    }
  }

  .modal-body {
    display: flex;
    justify-content: space-between;
    padding: 25px;
    position: relative;

    p {
      font-size: 1.1rem;
      margin-bottom: 5px;
    }

    .erro-c-red {
      color: #c53030;
    }

    & > * {
      margin-right: 20px;
      margin-bottom: 20px;
    }

    .auto-man {
      height: 58px;
      padding: 9px;
    }
  }

  .header {
    border-bottom: 1px #707070 solid;
    padding-bottom: 20px;

    h1 {
      font-size: 2.8rem;
      color: #fff;
      margin: 0 0 40px 0;
    }

    .login-information {
      & > * {
        margin: 0 20px 20px 0;
      }
    }
  }

  .content {
    width: 100%;
    padding: 0;

    section {
      border-bottom: 1px #707070 solid;
      padding-bottom: 20px;
      margin-bottom: 60px;

      & > * {
        margin: 0 20px 30px 0;
      }
    }

    h1 {
      font-size: 24px;
      color: #fff;
      margin-bottom: 40px;
    }

    h2 {
      font-size: 18px;
      color: #fff;
      margin-bottom: 20px;
    }

    .MuiTablePagination-root {
      color: #cccccc;

      .MuiTypography-root {
        font-size: 1.2rem;
      }

      .MuiSelect-root {
        font-size: 1.2rem;
      }

      .MuiSvgIcon-root {
        color: #cccccc;
      }
    }
  }

  .ReCAPTCHA {
    margin-top: 20px;
  }

  .buttons {
    margin: 40px 0;

    .help {
      background: none;
      border: 1px solid #fff;
      margin-right: 30px;
    }
  }
`;

export const FormControlLGPD = styled(FormControl)<Iprops>`
  width: 100%;
  max-width: 255px;

  .MuiInputBase-root {
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${props =>
        props.ownershipTypeError ? '#c53030' : '#eaeaea'};
    }

    svg {
      top: 5px;
      color: ${props =>
        props.ownershipTypeError
          ? '#c53030 !important'
          : 'rgba(0, 0, 0, 0.54)'};
    }
    font-size: 14px;
    color: ${props =>
      props.ownershipTypeError ? '#c53030' : 'rgba(0, 0, 0, 0.87)'};

    fieldset {
      border-color: ${props =>
        props.ownershipTypeError ? '#c53030 !important' : '#eaeaea'};

      &:hover fieldset {
        border-color: ${props =>
          props.ownershipTypeError ? '#c53030' : '#eaeaea'};
      }

      legend {
        border-bottom: 0;
        width: auto !important;
      }
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.ownershipTypeError ? '#c53030 !important' : '#1535ff !important'};
    }
  }

  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 14px;
    text-align: center;
    padding: 2px 10px;
    margin-left: -5px;
    color: ${props =>
      props.ownershipTypeError ? '#c53030' : 'rgba(0, 0, 0, 0.54)'};
  }
  .MuiInput-underline:before {
    border-bottom: 1px solid;
    border-color: ${props =>
      props.ownershipTypeError ? '#c53030' : 'rgba(0, 0, 0, 0.42)'};
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.identificationKeyError
        ? '#c53030 !important'
        : '#1535ff !important'};
  }

  .MuiInputLabel-outlined {
    background-color: #fff !important;
    color: ${props => (props.identificationKeyError ? '#c53030' : ' #a2a3a5')};
  }

  padding: 2px 10px;
  margin-left: -5px;
`;

export const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
  padding: 7px 14px;
  border-radius: 24px !important;
  height: 40px;
  width: 120px;

  & .MuiButton-label {
    color: #fff;
  }
`;

export const SearchButton = styled(Button)`
  && {
    background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
    padding: 7px 14px;
    border-radius: 4px;
    height: 53px;
    width: 165px;
    margin-left: 30px;

    & .MuiButton-label {
      color: #fff;
      font-size: 1.2rem;
    }
  }
`;

export const StyledTextField = styled(TextField)<Iprops>`
  width: 100%;
  max-width: 255px;

  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 14px;
    text-align: center;
    color: ${props =>
      props.identificationKeyError ? '#c53030' : 'rgba(0, 0, 0, 0.54)'};
  }

  .MuiInput-underline:before {
    border-bottom: 1px solid;
    border-color: ${props =>
      props.identificationKeyError ? '#c53030' : 'rgba(0, 0, 0, 0.42)'};
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.identificationKeyError
        ? '#c53030 !important'
        : '#1535ff !important'};
  }

  .MuiInputLabel-outlined {
    color: ${props => (props.identificationKeyError ? '#c53030' : ' #a2a3a5')};

    padding: 2px 10px;
    margin-left: -5px;
  }

  .MuiOutlinedInput-root {
    font-size: 14px;

    fieldset {
      border-color: ${props =>
        props.identificationKeyError ? '#c53030' : '#eaeaea'};
    }

    &:hover fieldset {
      border-color: ${props =>
        props.identificationKeyError ? '#c53030' : '#eaeaea'};
      border-color: ${props => !!props.disabled && '#bdbdbd'};
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.identificationKeyError
          ? '#c53030 !important'
          : '#1535ff !important'};
    }
  }
`;

export const MessageDPO = styled.textarea<Iprops>`
  border-radius: 4px;
  width: 100%;
  background: #fff;
  color: rgba(0, 0, 0, 0.87);
  padding: 10px;
  height: 90px;
  border: 1px solid;
  border-color: ${props => (props.messageError ? '#c53030' : '#eaeaea')};
`;
